<template>
    <el-table :data="tableData" stripe style="width: 100%" :cell-style="{'text-align':'center'}">
        <el-table-column prop="openNum" label="期号" align="center">
        </el-table-column>
        <el-table-column prop="openTime" label="时间" align="center">
            <template slot-scope="scope">
                {{ getTime(scope.row.openTime) }}
            </template>
        </el-table-column>
        <el-table-column prop="result" label="结果" align="center">
            <template slot-scope="scope">
                {{ getResult(scope.row.result) }}
            </template>
        </el-table-column>
        <el-table-column prop="num" label="预测" align="center">
            <template slot-scope="scope">
                {{ getGuessValue(scope.row.guess1) }}
            </template>
        </el-table-column>
        <el-table-column prop="num" label="结果" align="center">
            <template slot-scope="scope">
                <template v-if="getResult(scope.row.result) ==''">
                    <span ></span>
                </template>
                <template v-else-if="getGuessResult(scope.row) ==2">
                    <i class="el-icon-check" style="color: rgb(26, 250, 41); font-weight: 700; font-size: 20px;"></i>
                </template>
                <template v-else-if="getGuessResult(scope.row) ==1">
                    <i class="el-icon-check" style="color: rgb(26, 250, 41); font-weight: 700; font-size: 20px;"></i>
                </template>
                <template v-else-if="getGuessResult(scope.row) ==0">
                    <i class="el-icon-close" style="color: rgb(216, 30, 6); font-weight: 700; font-size: 20px;"></i>
                </template>
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    props: {
        tableData: {
            type: Array,
            default: null,
            require: true
        }
    },
    methods: {
        getResult(data) {
            if (data && data.length == 3) {
                return data[0] + "+" + data[1] + "+" + data[2] + "=" + (Number(data[0]) + Number(data[1]) + Number(data[2]))
            }
            return ""
        },
        getTime(time){
           return time.slice(5,16)
        },
        getGuessValue(data) {
            let guessData = ""
            switch (data[0]) {
                case 0: {
                    guessData += "大"
                    break
                }
                case 1:
                    {
                        guessData += "小"
                        break
                    }
            }
            guessData += ","
            switch (data[1]) {
                case 0: {
                    guessData += "单"
                    break
                }
                case 1:
                    {
                        guessData += "双"
                        break
                    }
            }
            return guessData

        },
        getGuessResult(data) {
            let winCount = 0
            if(data.guess1[0] ==0 && this.isBigNum(data)){
                winCount++
            }else if(data.guess1[0] ==1 && !this.isBigNum(data))
            {
                winCount++
            }
            if(data.guess1[1] ==0 && this.isOddNumber(data)){
                winCount++
            }else if(data.guess1[1] ==1 && !this.isOddNumber(data))
            {
                winCount++
            }
            console.log(winCount)
            return winCount
        },
        isBigNum(data) {

            if (data.sumResult >= 14) return true
            return false
        },
        isOddNumber(data) {
            if (data.sumResult == 0 || (data.sumResult % 2 == 0)) return false

            return true
        },
        isVerySmall(data) {
            if (data.sumResult <= 5) return true
            return false
        },
        isVersyBig(data) {
            if (data.sumResult >= 23) return true
            return false
        },
    }
}
</script>